<template>
  <v-container fluid>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.srol') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="srol" v-model="srol.srol" :items="srolList" @update:search-input="searchSrol" :label="$t('rtrck.ph.srol')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.registrant') }} / {{ $t('rtrck.title.regist.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="registrant" v-model="srol.registrant" :items="registrantList" @update:search-input="searchRegistrant" clearable :label="$t('rtrck.ph.user')" dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-time-range-picker-neo v-model="srol.regTerm" :clearable="true" @click:clear="clearRegTerm"></date-time-range-picker-neo>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.updated.by') }} / {{ $t('rtrck.title.upd.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="updater" v-model="srol.updater" :items="updaterList" @update:search-input="searchUpdater" :label="$t('rtrck.ph.user')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-time-range-picker-neo v-model="srol.updTerm" :clearable="true" @click:clear="clearUpdTerm"></date-time-range-picker-neo>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
export default {
  props: {
    params: {
      type: Object,
    },
  },
  data() {
    return {
      srolList: [],
      registrantList: [],
      updaterList: [],
    };
  },
  computed: {
    ...mapState('extra/auth/role-tracker', ['srol', 'initFilter']),
  },
  watch: {
    'srol.srol': {
      handler() {
        this.srolList = (() => {
          if (this.srol.srol === undefined) return [];
          else return [this.srol.srol];
        })();
      },
    },
    'srol.registrant': {
      handler() {
        this.registrantList = (() => {
          if (this.srol.registrant === undefined) return [];
          else return [this.srol.registrant];
        })();
      },
    },
    'srol.updater': {
      handler() {
        this.updaterList = (() => {
          if (this.srol.updater === undefined) return [];
          else return [this.srol.updater];
        })();
      },
    },
  },
  methods: {
    ...mapActions('extra/auth/role-tracker', ['setSrol']),
    async searchSrol(input) {
      if (input === null || input == this.srol.srol) return;
      this.srolList = await this.autoSearch('srol', { argName: input });
      this.srolList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async searchRegistrant(input) {
      if (input === null || input == this.srol.registrant) return;
      this.registrantList = await this.autoSearch('user', { bname: input });
      this.registrantList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async searchUpdater(input) {
      if (input === null || input == this.srol.updater) return;
      this.updaterList = await this.autoSearch('user', { bname: input });
      this.updaterList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async autoSearch(uri, params) {
      const {
        data: { items },
      } = await api.get(`/rtrck/search/auto-search/${uri}`, {
        params: {
          ...this.params,
          ...params,
        },
      });
      return items;
    },
    clearRegTerm() {
      let s = {
        ...this.srol,
      };
      s.regTerm = this.initFilter.srol.regTerm;
      this.setSrol(s);
    },
    clearUpdTerm() {
      let s = {
        ...this.srol,
      };
      s.updTerm = this.initFilter.srol.updTerm;
      this.setSrol(s);
    },
  },
};
</script>

<style scoped>
.row-h-34 {
  height: 34px;
}
.col-1 {
  padding-top: 10px;
}
.datepick-width {
  width: 190px;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 4px;
}
</style>
